"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserEvents = void 0;
var BrowserEvents;
(function (BrowserEvents) {
    BrowserEvents["PAGE_HIDE"] = "pagehide";
    BrowserEvents["POP_STATE"] = "popstate";
    BrowserEvents["VISIBILITY_CHANGE"] = "visibilitychange";
    BrowserEvents["SCROLL"] = "scroll";
    BrowserEvents["RESIZE"] = "resize";
    BrowserEvents["MOUSEDOWN"] = "mousedown";
    BrowserEvents["MOUSEMOVE"] = "mousemove";
    BrowserEvents["KEYDOWN"] = "keydown";
    BrowserEvents["TOUCHSTART"] = "touchstart";
})(BrowserEvents = exports.BrowserEvents || (exports.BrowserEvents = {}));
